import { Component, OnInit } from '@angular/core';
import {trigger, state, style, animate, transition} from '@angular/animations';
import { JwtHelperService } from "@auth0/angular-jwt";
import { HtmlParser } from '@angular/compiler';
import { ConstantConfigService } from '../../../services/constant-config.service';
import {AuthenticationService} from '../../../services/authentication.service';
import { ActivatedRoute, Router} from '@angular/router';
const helper = new JwtHelperService();
@Component({
  selector: 'sidebar-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  animations: [
    trigger('toggleUserMenu', [
      state('void', style({
        height: '0',
        opacity: '0'
      })),
      state('true', style({
        height: '*',
        opacity: '1'
      })),
      transition(':enter', animate('200ms ease-in')),
      transition(':leave', animate('200ms ease-out'))
    ])
  ]
})
export class UserComponent implements OnInit {
  userMenu: boolean = false;
  decodedToken: any = {};
  _accessToken: string = "";
  full_name : string = "";
  email : string = ""

  constructor(private authService : AuthenticationService,private router : Router,) {
    this._accessToken = ConstantConfigService.accessToken;
   }

  ngOnInit() {
    const myToken = localStorage.getItem(this._accessToken);
    if (myToken != "" && myToken!=null) {
      this.decodedToken = helper.decodeToken(myToken);
      this.full_name = this.decodedToken.userdata.full_name;
      this.email = this.decodedToken.userdata.email;
    }


  }
  logout() {
    console.log("Hellow");
    this.authService.logout();
    this.router.navigate(['/login']);
  }

}
